import { selectComponentState } from 'projectRedux/store';
import { eppTerminalTypeAdapter } from '../adapters/eppTerminalTypeAdapter';

export const {
  selectAll: selectAllEppTerminalTypes,
  selectById: selectEppTerminalTypeById,
  selectEntities: selectEppTerminalTypeEntities,
} = eppTerminalTypeAdapter.getSelectors((state) => selectComponentState(state).eppTerminalTypes);
